module.exports = __webpack_public_path__ + "img/flow-num-1.395b12f8.svg";